import React, { useState } from "react";
import { isNil, map } from "lodash";
import { CaretRightOutlined } from "@ant-design/icons";
import { AiccPromptModel } from "types/model/aiccPrompt";
import { AiccSandboxFlowUsed, AiccSandboxRunFacts, AiccSandboxSettings } from "types/model/aiccPromptSandbox";
import { FACTS_COST, FACTS_RAN_ON, FACTS_ROUNDS, FACTS_TOKENS, FACTS_UNPRICED, FLOWS_TITLE } from "../configs";
import styles from "../Sandbox.module.scss";
import { settingsLine } from "./ranOn";

interface Props {
  facts: AiccSandboxRunFacts;
  settings?: AiccSandboxSettings;
  modelsById: Record<string, AiccPromptModel>;
  flowsUsed?: AiccSandboxFlowUsed[];
  rounds?: { count: number; isArmed: boolean };
}

function RunFacts({ facts, settings, modelsById, flowsUsed = [], rounds }: Props) {
  const [areFlowsOpen, setAreFlowsOpen] = useState(false);
  const { cost } = facts;

  return (
    <div className={styles.facts}>
      <div className={styles.factsLine}>
        {!!settings && <span>{`${FACTS_RAN_ON} ${settingsLine(settings, modelsById)}`}</span>}
        {!!rounds && <span>{FACTS_ROUNDS(rounds.count, rounds.isArmed)}</span>}
        {!!facts.usage && <span>{FACTS_TOKENS(facts.usage.inputTokens, facts.usage.outputTokens)}</span>}
        {!!cost && <span>{isNil(cost.usd) ? FACTS_UNPRICED(cost.unpricedModels) : FACTS_COST(cost.usd)}</span>}
      </div>
      {!!flowsUsed.length && (
        <>
          <button type="button" className={styles.factsToggle} onClick={() => setAreFlowsOpen(!areFlowsOpen)}>
            <CaretRightOutlined rotate={areFlowsOpen ? 90 : 0} />
            {FLOWS_TITLE(flowsUsed.length)}
          </button>
          {areFlowsOpen && (
            <div className={styles.flows}>
              {map(flowsUsed, ({ flowId, effective }) => (
                <div key={flowId} className={styles.flowRow}>
                  <span className={styles.flowName}>{flowId}</span>
                  <span className={styles.flowSettings}>{settingsLine(effective, modelsById)}</span>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default RunFacts;
